/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AchievementBoard,
  ErrorEnvelope,
  Hidden,
  HiddenUpdate,
  MemberAchievements,
  SeenAwards,
  SharedAchievement,
  Sharing,
  SharingUpdate
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMyAchievementsUrl = () => {




  return `/api/v1/me/achievements`
}

/**
 * The user's board across every team they are in: each offered achievement as they may
 * see it, the totals, the unseen unlocks and their switches. From a session only (403
 * `FORBIDDEN` for a token, which is bound to one team).
 * @summary Get My Achievements
 */
export const getMyAchievements = async ( options?: Parameters<typeof apiRequest>[1]): Promise<AchievementBoard> => {

  return apiRequest<AchievementBoard>(getGetMyAchievementsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyAchievementsQueryKey = () => {
    return [
    `/api/v1/me/achievements`
    ] as const;
    }


export const getGetMyAchievementsQueryOptions = <TData = Awaited<ReturnType<typeof getMyAchievements>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAchievementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAchievements>>> = ({ signal }) => getMyAchievements({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyAchievementsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAchievements>>>
export type GetMyAchievementsQueryError = ErrorType<ErrorEnvelope>


export function useGetMyAchievements<TData = Awaited<ReturnType<typeof getMyAchievements>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAchievements>>,
          TError,
          Awaited<ReturnType<typeof getMyAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAchievements<TData = Awaited<ReturnType<typeof getMyAchievements>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAchievements>>,
          TError,
          Awaited<ReturnType<typeof getMyAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAchievements<TData = Awaited<ReturnType<typeof getMyAchievements>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Achievements
 */

export function useGetMyAchievements<TData = Awaited<ReturnType<typeof getMyAchievements>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyAchievementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetAchievementsHiddenUrl = () => {




  return `/api/v1/me/achievements/hidden`
}

/**
 * Hide achievements, on or off: the trophy, the cards, the popover, the tab and the
 * shared lists. Awards still accrue. From a session only.
 * @summary Set Achievements Hidden
 */
export const setAchievementsHidden = async (hiddenUpdate: HiddenUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Hidden> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Hidden>(getSetAchievementsHiddenUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(hiddenUpdate)
  }
);}





export const getSetAchievementsHiddenMutationKey = () => ['setAchievementsHidden'] as const;

export const getSetAchievementsHiddenMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAchievementsHidden>>, TError,SetAchievementsHiddenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof setAchievementsHidden>>, TError,SetAchievementsHiddenMutationVariables, TContext> => {

const mutationKey = getSetAchievementsHiddenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAchievementsHidden>>, SetAchievementsHiddenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAchievementsHidden(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAchievementsHiddenMutationResult = NonNullable<Awaited<ReturnType<typeof setAchievementsHidden>>>
    export type SetAchievementsHiddenMutationBody = HiddenUpdate
    export type SetAchievementsHiddenMutationError = ErrorType<ErrorEnvelope>
    export type SetAchievementsHiddenMutationVariables = {data: HiddenUpdate}

    /**
 * @summary Set Achievements Hidden
 */
export const useSetAchievementsHidden = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAchievementsHidden>>, TError,SetAchievementsHiddenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAchievementsHidden>>,
        TError,
        SetAchievementsHiddenMutationVariables,
        TContext
      > => {
      return useMutation(getSetAchievementsHiddenMutationOptions(options), queryClient);
    }
    export const getMarkAchievementsSeenUrl = () => {




  return `/api/v1/me/achievements/seen`
}

/**
 * The named unlocks seen: the popover opened, or the card was read. One the user does
 * not hold, or saw already, changes nothing. From a session only.
 * @summary Mark Achievements Seen
 */
export const markAchievementsSeen = async (seenAwards: SeenAwards, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<void>(getMarkAchievementsSeenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(seenAwards)
  }
);}





export const getMarkAchievementsSeenMutationKey = () => ['markAchievementsSeen'] as const;

export const getMarkAchievementsSeenMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAchievementsSeen>>, TError,MarkAchievementsSeenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof markAchievementsSeen>>, TError,MarkAchievementsSeenMutationVariables, TContext> => {

const mutationKey = getMarkAchievementsSeenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAchievementsSeen>>, MarkAchievementsSeenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  markAchievementsSeen(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAchievementsSeenMutationResult = NonNullable<Awaited<ReturnType<typeof markAchievementsSeen>>>
    export type MarkAchievementsSeenMutationBody = SeenAwards
    export type MarkAchievementsSeenMutationError = ErrorType<ErrorEnvelope>
    export type MarkAchievementsSeenMutationVariables = {data: SeenAwards}

    /**
 * @summary Mark Achievements Seen
 */
export const useMarkAchievementsSeen = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAchievementsSeen>>, TError,MarkAchievementsSeenMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAchievementsSeen>>,
        TError,
        MarkAchievementsSeenMutationVariables,
        TContext
      > => {
      return useMutation(getMarkAchievementsSeenMutationOptions(options), queryClient);
    }
    export const getListMemberAchievementsUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/achievements/members`
}

/**
 * Each member who shares in this team and does not hide: their count and best tier
 * here.
 * @summary List Member Achievements
 */
export const listMemberAchievements = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<MemberAchievements[]> => {

  return apiRequest<MemberAchievements[]>(getListMemberAchievementsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMemberAchievementsQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/achievements/members`
    ] as const;
    }


export const getListMemberAchievementsQueryOptions = <TData = Awaited<ReturnType<typeof listMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMemberAchievementsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberAchievements>>> = ({ signal }) => listMemberAchievements(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMemberAchievementsQueryResult = NonNullable<Awaited<ReturnType<typeof listMemberAchievements>>>
export type ListMemberAchievementsQueryError = ErrorType<ErrorEnvelope>


export function useListMemberAchievements<TData = Awaited<ReturnType<typeof listMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberAchievements>>,
          TError,
          Awaited<ReturnType<typeof listMemberAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberAchievements<TData = Awaited<ReturnType<typeof listMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMemberAchievements>>,
          TError,
          Awaited<ReturnType<typeof listMemberAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMemberAchievements<TData = Awaited<ReturnType<typeof listMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Member Achievements
 */

export function useListMemberAchievements<TData = Awaited<ReturnType<typeof listMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMemberAchievementsQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetAchievementsSharedUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/achievements/sharing`
}

/**
 * Share the awards earned in this team with its members, or stop; private by default.
 * Any member, for themselves, from a session only.
 * @summary Set Achievements Shared
 */
export const setAchievementsShared = async (teamId: string,
    sharingUpdate: SharingUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Sharing> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Sharing>(getSetAchievementsSharedUrl(teamId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sharingUpdate)
  }
);}





export const getSetAchievementsSharedMutationKey = () => ['setAchievementsShared'] as const;

export const getSetAchievementsSharedMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAchievementsShared>>, TError,SetAchievementsSharedMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof setAchievementsShared>>, TError,SetAchievementsSharedMutationVariables, TContext> => {

const mutationKey = getSetAchievementsSharedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAchievementsShared>>, SetAchievementsSharedMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  setAchievementsShared(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAchievementsSharedMutationResult = NonNullable<Awaited<ReturnType<typeof setAchievementsShared>>>
    export type SetAchievementsSharedMutationBody = SharingUpdate
    export type SetAchievementsSharedMutationError = ErrorType<ErrorEnvelope>
    export type SetAchievementsSharedMutationVariables = {teamId: string;data: SharingUpdate}

    /**
 * @summary Set Achievements Shared
 */
export const useSetAchievementsShared = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAchievementsShared>>, TError,SetAchievementsSharedMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAchievementsShared>>,
        TError,
        SetAchievementsSharedMutationVariables,
        TContext
      > => {
      return useMutation(getSetAchievementsSharedMutationOptions(options), queryClient);
    }
    export const getGetMemberAchievementsUrl = (teamId: string,
    userId: string,) => {




  return `/api/v1/teams/${teamId}/members/${userId}/achievements`
}

/**
 * A teammate's awards earned in this team, while they share here and do not hide; else
 * 404, the same for every reason, an admin's call included.
 * @summary Get Member Achievements
 */
export const getMemberAchievements = async (teamId: string,
    userId: string, options?: Parameters<typeof apiRequest>[1]): Promise<SharedAchievement[]> => {

  return apiRequest<SharedAchievement[]>(getGetMemberAchievementsUrl(teamId,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMemberAchievementsQueryKey = (teamId: string,
    userId: string,) => {
    return [
    `/api/v1/teams/${teamId}/members/${userId}/achievements`
    ] as const;
    }


export const getGetMemberAchievementsQueryOptions = <TData = Awaited<ReturnType<typeof getMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberAchievementsQueryKey(teamId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberAchievements>>> = ({ signal }) => getMemberAchievements(teamId,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberAchievementsQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberAchievements>>>
export type GetMemberAchievementsQueryError = ErrorType<ErrorEnvelope>


export function useGetMemberAchievements<TData = Awaited<ReturnType<typeof getMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberAchievements>>,
          TError,
          Awaited<ReturnType<typeof getMemberAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberAchievements<TData = Awaited<ReturnType<typeof getMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberAchievements>>,
          TError,
          Awaited<ReturnType<typeof getMemberAchievements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberAchievements<TData = Awaited<ReturnType<typeof getMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Member Achievements
 */

export function useGetMemberAchievements<TData = Awaited<ReturnType<typeof getMemberAchievements>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberAchievements>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberAchievementsQueryOptions(teamId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






